// extracted by mini-css-extract-plugin
module.exports = {"FeaturesGrid":"styles_FeaturesGrid__yPxJr","grid":"styles_grid__z0KhW","col":"styles_col__JyRZM","icon":"styles_icon__AHMkV"};